module.exports = __webpack_public_path__ + "img/profile2_invoiceweb.3745e128.png";